export class Controller {

    /** @ngInject */
    constructor(UserLabelsService) {
        this.UserLabelsService = UserLabelsService;
		
    }

    $onInit() {
	const companyId= this.resolve.companyId;
     const userLabelId = this.resolve.userLabelId;
    }

    remove() {
	const companyId= this.resolve.companyId;
     const labelId = this.resolve.userLabelId;
const userIds=this.resolve.userIds;
        this.isSaving = true;
        this.UserLabelsService
            .removeCompanyUsers(
                {companyId,
                labelId},
                userIds
            ).$promise
            .then(() => this.close(userIds))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/remove/remove-users-from-label.controller.js